import React from 'react';
import { Link } from 'react-router-dom';
import { useLibrary } from '../lib/Library';
import PosterCard from './PosterCard';

const MyList = () => {
  const { items } = useLibrary();

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1 className="page-title">My list</h1>
          <p className="page-sub">
            {items.length ? `${items.length} saved` : 'Nothing saved yet'}
          </p>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="empty">
          Add anything with the + button.{' '}
          <Link to="/discover" style={{ color: 'var(--ac)' }}>
            Start in Discover →
          </Link>
        </div>
      ) : (
        <div className="grid">
          {items.map((title) => (
            <PosterCard key={`${title.type}-${title.id}`} title={title} variant="grid" />
          ))}
        </div>
      )}
    </div>
  );
};

export default MyList;
